var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.id !== null
    ? _c("div", { staticClass: "document-upload-item" }, [
        _c("div", { staticClass: "document-upload-item_bar" }),
        _c("div", { staticClass: "document-upload-item_name" }, [
          _c("p", { staticClass: "text-medium gray" }, [
            _vm._v(_vm._s(_vm.name)),
          ]),
        ]),
        _c("div", { staticClass: "document-upload-item_actions" }, [
          _c(
            "div",
            {
              staticClass: "document-upload-item_actions_icon",
              on: { click: _vm.handleDownloadClick },
            },
            [_c("svgicon", { attrs: { icon: "ico-download", width: "18" } })],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }